const resources = {
    checkYourBalance: 'Vérifiez votre solde',
    and: '&',
    addToWallet: 'Add to Wallet',
    enterGiftCardNumber: 'Entrez le numéro à 16 chiffres et le NIP de votre carte-cadeau.',
    reCaptcha: 'Sephora utilise ReCaptcha et les utilisateurs sont assujettis aux normes de Google en matière de',
    privacyPolicy: 'politique de confidentialité',
    terms: 'de paiement',
    balanceCall: 'Pour entendre votre solde, appelez',
    currentBalance: 'Solde actuel',
    cardNumber: 'Numéro de carte',
    pin: 'NIP',
    checkBalance: 'Vérifier le solde',
    balance: 'Balance',
    giftCardBalanceModalTitle: 'Your Gift Card Balance',
    appleWalletDisclaimer: 'This balance will continue to be available on your physical/eGift card as well as your Apple Wallet Pass.',
    googleWalletDisclaimer: 'This balance will continue to be available on your physical/eGift card as well as your Google Wallet Pass.',
    addTo: 'Add to',
    appleWallet: 'Apple Wallet',
    googleWallet: 'Google Wallet',
    done: 'Done'
};

export default function getResource(label) {
    return resources[label];
}
